import sidebar from './modules/sidebar.js'
import app from './modules/app.js'
import {importModules} from "../../core/utils/translationUtil";

export default importModules({sidebar, app})